/**
 * Created by Johan Schram - KOSMEO ANALITICS - https://kosmeo-a.com on 16/05/2017.
 */

// Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import './drop-down-button.css';




var DropDownButton = CreateReactClass({
    propTypes : {
        onSelect :  PropTypes.func,
        listItem : PropTypes.array,
        choiceId : PropTypes.number,
        placeHolder : PropTypes.string
    },
    defaultProps : {
        onSelect :  function(){},
        listItem : [],
        placeHolder : 'Sélectionner',
        choiceId : -1
    },
    getInitialState: function () {
        return {
            isActive : false,
            choice : null
        };
    },
    componentDidMount() {
        if (this.props.choiceId >-1 ){

            for (var item of this.props.listItem){
                if (this.props.choiceId === item.id){
                    this.setState({
                        choice : item
                    });
                    break
                }
            }
        }
    },
    componentWillReceiveProps(nextProps){
        if (nextProps.choiceId >-1 ){
            for (var item of nextProps.listItem){
                if (nextProps.choiceId === item.id){
                    this.setState({
                        choice : item
                    });
                    break
                }
            }
        }
    },
    onClick : function(item){
        this.setState({
            choice : item,
            isActive : false
        });

        this.props.onSelect(item)
    },
    onMainClick : function(){
        var isActive = this.state.isActive;
        this.setState({
            isActive : !isActive
        });
    },
    onBlur : function(){
        // console.log("blur");
        this.setState({
            isActive : false
        });
    },
    render: function () {

        var renderChoice  = function(that){
            if (that.state.choice){
                return <div className="flexComponentOne">{that.state.choice.lib}</div>
            }
            else {
                if (that.props.placeHolder) {
                   return <div className="flexComponentOne">{that.props.placeHolder}</div>
                }
                else {
                    return <div className="flexComponentOne"><i>Sélectionner</i></div>
                }
            }
        };

        var renderDropDownButtonList  = function(that){
            if (that.state.isActive){
                return <DropDownButtonList listItem={that.props.listItem} onClick={that.onClick} />
            }
        };

        return (
            <div className="dropDownButton ligneFlexStartCentered" tabIndex="0" onClick={this.onMainClick} onBlur={this.onBlur}>
                {renderChoice(this)}
                <div className="flexComponentNone" style={{paddingLeft : 10}}>
                    <span className="fa fa-caret-down"></span>
                </div>

                {renderDropDownButtonList(this)}
            </div>
        )
    }
});

var DropDownButtonList = CreateReactClass({
    propTypes : {
        onClick :  PropTypes.func,
        listItem : PropTypes.array
    },
    defaultProps : {
        onClick :  function(){},
        listItem : []
    },
    handleClick(item) {
        return this.props.onClick(item)
    },
    render: function () {

        var renderList = this.props.listItem.map(function(item, index){

            return (
                <li key={index} onClick={this.handleClick.bind(this, item)} >
                    {item.lib}
                </li>
            );

        }.bind(this));

        return (
            <div className="DropDownButtonList">
                <ul>
                    {renderList}
                </ul>
            </div>
        )
    }
});

module.exports = DropDownButton;





// WEBPACK FOOTER //
// ./src/components/common/drop-down-button.js